import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import api from "../Api";
import TableFooter from "../components/TableFooter";
import DeleteModal from "../components/DeleteModal";
import { Link, useNavigate } from "react-router-dom";
import Popup from "../components/PopUP";
import ActivateModal from "../components/ActivateModal";
import DeactivateModal from "../components/DeactivateModal";
import {IMAGE_URL} from "../utils/constants";


export default function Aircraft() {
  const navigate = useNavigate();
  const [aircraft, setAicraft] = useState()
  const [loading, setLoading] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");
  const [pagination, setPagination] = useState({
    count: 0,
    total_pages: 0,
    next: 0,
    previous: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("")
  const [showActiveModal, setActiveShowModal] = useState(false);
  const [showDeactiveModal, setDeactiveShowModal] = useState(false);

  useEffect(() => {
    if (popupMessage === "") {
      if (loading === false) {
        setPopupMessage("Aircrafts loaded successfully")
      }
      else {
        setPopupMessage("Aircrafts loading  please wait ...")
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/airplane-service/aircraft/?page=" + currentPage + "&q=" + query);
        setAicraft(response.data)
        setPagination({
          count: response.data.count,
          total_pages: response.data.total_pages,
          next: response.data.next,
          previous: response.data.previous
        });
      } catch (error) {
        console.error("API Error:", error.message);
      }

      setLoading(false)
    };

    fetchData();
  }, [currentPage, query, loading])

  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);


  // const handleDeleteClick = (item) => {
  //     setSelectedItem(item);
  //     setShowModal(true);
  // };

  const handleConfirmDelete = () => {
    console.log("Deleting:", selectedItem.id);
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleConfirmActivation = async () => {
    console.log("activating:", selectedItem.id);
    setLoading(true)
    try {
      const response = await api.patch('/airplane-service/aircraft/status', { "aircraft_id": selectedItem.aircraft_id, "action": "activate" })
      console.log("Activation response:", response.data);
      setPopupMessage(response.data.details || "Aircraft activated successfully.")
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("An error occurred during activation")
      return;
    }
    setActiveShowModal(false);
    setSelectedItem(null);
    setLoading(false)
  };

  const handleConfirmDeactivation = async (item) => {
    console.log("Item to delete:", item);
    setLoading(true)
    try {
      const response = await api.patch('/airplane-service/aircraft/status', { "aircraft_id": selectedItem.aircraft_id, "action": "deactivate" })
      console.log("deActivation response:", response.data);
      setPopupMessage(response.data.details || "Aircraft deactivated successfully.")
    }
    catch (error) {
      console.log("Activation error:", error);
      setPopupMessage("An error occurred during activation")
      return;
    }
    setSelectedItem(item);
    setDeactiveShowModal(false);
    setLoading(false)
  };


  const handleActivateClick = (item) => {
    console.log("Item to delete:", item);
    setSelectedItem(item);
    setActiveShowModal(true);
  };

  const handleDeactivateClick = (item) => {
    console.log("Item to deactivate:", item);
    setSelectedItem(item);
    setDeactiveShowModal(true);
  };

  return (
    <div className="user-management-page">
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      {/* Sidebar */}
      <Sidebar />

      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Content Section */}
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1>Aircraft Management</h1>
                      </div>
                      <div className="d-flex flex-end">
                        <Link to="/aircraft-create" className="secondary_btn">+ Add Aircraft</Link>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  {loading ? 
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  :
                    <div className="common-table-wrapper mt-4">
                      <div className="common-table-filter-wrapper">
                        <div className="common-left-blk">
                          <div className="common_sub_heading_wrapper mb-0">
                            <h2>Aircraft Listing</h2>
                          </div>
                        </div>
                        <div className="common-right-blk">
                          <div className="common-sort-blk">
                            <div className="common-search-blk">
                              <input type="search" className="form-control" id="search" placeholder="Search" onChange={(e) => setQuery(e.target.value)} name="aircraft" />
                            </div>
                          </div>
                          <Link to='/upload-aircraft' className="secondary_btn">Upload JSON</Link>
                        </div>
                      </div>

                      <div className="table-blk table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Image</th>
                              <th>Model</th>
                              <th>ICAO</th>
                              <th>Manufacturer</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {aircraft && aircraft.results.map((craft, index) => (
                              <tr>
                                <td>{(index + 1) + (currentPage - 1) * 20}</td>
                                <td><img src={craft.Image} alt="Aircraft" className="table_img"></img></td>
                                <td>{craft.Aircraft_Model}</td>
                                <td>{craft.ICAO_Type_Code}</td>
                                <td className="text-capitalize">{craft.Manufacturer.company_name}</td>

                                <td>
                                  {craft.is_active ? <span className="badge bg-light text-success">Active</span> :
                                    <span className="badge bg-light text-danger">Deactive</span>
                                  }
                                </td>
                                <td className="">
                                  <Link to={`/aircraft/${craft.id}`} className="border-0 bg-white">
                                    <img src={IMAGE_URL+"eye-tbl-icon.svg"} alt="View" />
                                  </Link>
                                  <button onClick={() => navigate(`/aircraft/update/${craft.id}`)} className="border-0 bg-white ms-1">
                                    <img src={IMAGE_URL+"edit-icon.svg"} alt="Edit" />
                                  </button>

                                  {craft.is_active ?
                                    <button
                                      className="border-0 bg-white"
                                      onClick={() => handleDeactivateClick({ "aircraft_id": craft.id, "name": craft.Aircraft_Model })}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="bi bi-toggle-off ms-1"
                                        viewBox="0 0 16 16">
                                        <path
                                          d="M11 4a4 4 0 0 1 0 8H8a5 5 0 0 0 2-4 5 5 0 0 0-2-4zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8M0 8a5 5 0 0 0 5 5h6a5
                                           5 0 0 0 0-10H5a5 5 0 0 0-5 5"/>
                                      </svg>
                                    </button>
                                    :
                                    <button
                                      className="border-0 bg-white ms-1"
                                      onClick={() => handleActivateClick({ "aircraft_id": craft.id, "name": craft.Aircraft_Model })}
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        width="26" height="26" fill="currentColor" class="bi bi-toggle-on"
                                        viewBox="0 0 16 16">
                                        <path d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8" />
                                      </svg>
                                    </button>
                                  }

                                  {/* <button
                                        className="border-0 bg-white"
                                        onClick={() => handleDeleteClick(craft.company_name)}
                                    >
                                        <img src="assets/images/trash-icon.svg" alt="Trash" />
                                    </button> */}
                                </td>
                              </tr>
                            ))
                            }
                          </tbody>
                        </table>
                      </div>

                      {/* footer */}
                      <TableFooter
                        pagination={pagination}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  }
                  {/* Table End */}
                  {/* Delete Modal */}
                  <DeleteModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onConfirm={handleConfirmDelete}
                    itemName={selectedItem?.name}
                  />

                  <DeactivateModal
                    show={showDeactiveModal}
                    onClose={() => setDeactiveShowModal(false)}
                    onConfirm={handleConfirmDeactivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />
                  <ActivateModal
                    show={showActiveModal}
                    onClose={() => setActiveShowModal(false)}
                    onConfirm={handleConfirmActivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}


